import { createApp } from 'vue'
import App from './App.vue'
import router from './router.js'
import { loadConfig } from './config/loader.js'
import { initAxios } from './plugins/axiosPlugin.js';
import '../node_modules/vuetify/_styles.scss'
import { createVuetify } from '../node_modules/vuetify'
import store from './store.js'
import * as components from '../node_modules/vuetify/lib/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import './styles/mainStyles.css'
import VueDatePicker from '../node_modules/@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

const vuetify = createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  },
  components,
  directives
})

loadConfig().then(config => {
  initAxios(config, { onUnauthorized: () => { try { store.commit('openLoginDialog') } catch(_) {} } });

  const app = createApp(App)
  app.provide('config', config)

  app.use(vuetify)
  app.use(store)
  app.use(router)
  app.component('VueDatePicker', VueDatePicker)



  app.mount('#app')
}).catch(err => {
  console.error('Fehler beim Laden der config.json:', err)
  alert('Die Anwendung konnte nicht gestartet werden! Warscheinlich liegt ein fehler in der Config vor.')
})
